import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import API_PATH from "../../constants/config.json";
import file_import_requirements_and_best_practices_1 from "../../assets/images/file_import_requirements/1_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_2 from "../../assets/images/file_import_requirements/2_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_3 from "../../assets/images/file_import_requirements/3_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_4 from "../../assets/images/file_import_requirements/4_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_5 from "../../assets/images/file_import_requirements/5_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_6 from "../../assets/images/file_import_requirements/6_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_7 from "../../assets/images/file_import_requirements/7_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_8 from "../../assets/images/file_import_requirements/8_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_9 from "../../assets/images/file_import_requirements/9_file_import_requirements_and_best_practices.png";
import file_import_requirements_and_best_practices_10 from "../../assets/images/file_import_requirements/10_file_import_requirements_and_best_practices.png";
import Grid from '@material-ui/core/Grid';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    float:'left',
    padding: '10px',    
    border: '1px solid #24618E',
    borderRadius: '5px',
    '& h5': {     
      margin: '0px 0 10px',
      '@media only screen and (max-width: 3500px)': { 
        fontSize: '16pt',       
      },
      '@media only screen and (min-width: 3501px)': {   
        fontSize: '26pt',     
      },
    },
    '& p': {
      fontFamily: 'Avenir_Medium !important'
    }
  },
  mainBlock: {
    padding: '10px',
    position: 'absolute',
    height: 'auto ',
    width: '100%',
    float: 'left',
    background: '#fff',
    marginTop: '2%',
    zIndex: '1',    
    '& h4': {      
      margin: '0',
      color: '#24618E',      
      '@media only screen and (max-width: 3500px)': { 
        fontSize: '20pt',
        marginTop: '20px',       
      },
      '@media only screen and (min-width: 3501px)': {   
        fontSize: '30pt',
        marginTop: '0px',      
      },
    }
  },
  tabInnerBlock:{
    width: '100%',
    float: 'left',   
    overflowX: 'hidden',
    overflowY: 'scroll',  
  },
  boldPara: {
    fontWeight: "bolder"
  },
  unorderedList: {
    marginTop: '5px',
    paddingTop: 0,
  },
  helpMain : {
    color : '333',
    borderTop : '1px solid #eee',
    borderRight : '1px solid #eee',    
    marginBottom : '20px',
    marginTop : '20px'
  },
  stepsHelp : {
    padding : '10px',
    borderBottom : '1px solid #eee',
    borderLeft : '1px solid #eee',
    borderRadius : '3px'
  },
  helpTitle : {

  },
  helpTestItalic : {
    fontStyle : 'italic'
  }
}));

export default function FileImportRequirementsAndBestPractices() {

  let scHeight = window.innerHeight;
  
  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    scHeight = window.innerHeight - 165;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    scHeight = window.innerHeight - 175;
  }
  else if (window.screen.width >= 3501) {
    scHeight = window.innerHeight - 235;
  }
  else {
    scHeight = window.innerHeight - 165;
  }

  const classes = useStyles();
  const theme = useTheme();
  const [getFileStorage, setFileStorage] = React.useState();
  const [getCloudStorage, setCloudStorage] = React.useState();
  const [screenHeight, setScreenHeight] = React.useState(scHeight);

  window.onresize = function () {
    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      scHeight = window.innerHeight - 165;
      setScreenHeight(scHeight);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      scHeight = window.innerHeight - 175;
      setScreenHeight(scHeight);
    }
    else if (window.screen.width >= 3501) {
      scHeight = window.innerHeight - 235;
      setScreenHeight(scHeight);
    }
    else {
      scHeight = window.innerHeight - 165;
      setScreenHeight(scHeight);
    }
  };
  // This code is use to change window viewport height

  const fileUploadLimitSize = API_PATH.fileUploadLimit;

  React.useEffect(
    () => {
      getFileData();
    }, []
  );


  const getFileData = () => {
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getFileSize
      })
        .then(async function (response) {
          if (response && response.data.data) {
            let resData = response.data.data;

            let fileStorage = getFileFromArray(resData, "file_storage")
            let fS = bytesToSize(fileStorage.file_size);
            setFileStorage(fS);

            let cloudStorage = getFileFromArray(resData, "cloud_storage")
            let cs = bytesToSize(cloudStorage.file_size);
            setCloudStorage(cs);

          }
        })
        .catch(function (error) {
          console.log(error);
        })
    } catch (error) {
      console.error(error);
    }
  }

  function getFileFromArray(fileArray, fileExt) {
    let temp = fileArray.find((fileEle, index) =>
      (fileEle.file_type.trim() === fileExt ||
        fileEle.file_type.trim() === fileExt.toString().toUpperCase())
    )
    return temp;
  }

  function bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  }



  return (
    <React.Fragment>
      <div className={classes.mainBlock}>
        <h4>File Import Requirements and Best Practices</h4>
        <hr style={{ marginTop: '0px' }} />
        <div className={classes.root}>
        <div className={classes.tabInnerBlock} style={{height: screenHeight.toString() + 'px' }}>
          <p style={{ marginBottom: '0px', marginTop: '0px' }}>
          DataPoint supports drag and drop data import for midblock and intersection stations. Once files are imported using the Import Data pop-up, DataPoint identifies the file type and Station ID using the files’ internal metadata. The files then appear on the Data Management page and must be individually approved in order to be saved into the database.
          </p>

          <h5 className={classes.boldPara} style={{ marginBottom: '0px', marginTop: '15px' }}> Accepted file types </h5>
          <p style={{ marginBottom: '0px', marginTop: '0px' }}>
            DataPoint accepts files in nearly any format for the purpose of storing those files for reference.  Files must be in the following formats to be processed for use in summaries, calculations, and in-app displays.
          </p>

          <p style={{ marginBottom: '0px', marginTop: '15px' }}>
            Midblock stations accept .prn files. QC generates .prn files from Jamar’s TraxPro software, although other software supports .prn generation as well. These files can be viewed in a text editing program like Notepad or Notepad ++.
          </p>

          <p style={{ marginBottom: '0px', marginTop: '15px' }}>
            Intersection stations accept 1) .csv exports from Miovision’s web site and 2) .txt exports from Jamar’s PetraPro software.
          </p>

          <p style={{ marginBottom: '0px', marginTop: '15px' }}>
            QC’s Count Support Services team can assist with conversion of files that are not currently supported by direct import. Support for additional file types is added based on demand.
            This guide provides instructions for creating compatible midblock and intersection files for direct import to DataPoint.
          </p>

          <h5 className={classes.boldPara} style={{ marginBottom: '0px', marginTop: '15px' }}> Import Limitations </h5>
          <p style={{ marginBottom: '0px', marginTop: '0px' }}>
            To ensure that the application remains responsive and can process files in a timely fashion, there are some limitations to the file import process:
          </p>
          <ul className={classes.unorderedList}>
            <li>A maximum of 100 files can be imported in a single batch</li>
            <li>Individual count files must be less than 2 MB in size</li>
            <li>PDF, JPEG, or other files for storage must be less than 5 MB in size</li>
          </ul>   

          <h5 className={classes.boldPara} style={{ marginBottom: '0px', marginTop: '15px' }}> Supported Import Formats </h5> 

          <h5 className={classes.boldPara} style={{ marginBottom: '0px', marginTop: '15px' }}> Exporting a .prn file from TraxPro </h5>
          <p style={{ marginBottom: '0px', marginTop: '0px' }}>
            DataPoint supports the import of volume, speed, and class reports. Reports must be in 15- or 60-minute intervals.  Most traffic count processing software is capable of exporting .prn files, but the easiest way to create a DataPoint-compatible .prn is to use Jamar’s TraxPro software.
          </p> 
          <Grid item xs={12} className={classes.helpMain} container >
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <label>1) Create a new count in TraxPro (File &gt; New)</label>
              <p className={classes.helpTestItalic}>Create A New Count pop-up in TraxPro. These settings will create a blank 24-hour bidirectional volume file in 15-minute intervals.</p>              
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>
            <img src={file_import_requirements_and_best_practices_1} alt="Create a new count in TraxPro (File &gt; New)" style={{width:'450px'}}/>          
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <label>2) Edit the count start date and time (Edit &gt; Edit Count Header)</label>
              <p className={classes.helpTestItalic}>Edit Count Header pop-up in TraxPro. These settings are for a count starting at midnight on April 6th, 2021 for Station ID MB-018TZ.</p>              
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>
            <img src={file_import_requirements_and_best_practices_2} alt="2) Edit the count start date and time (Edit &gt; Edit Count Header)" style={{width:'100%',maxWidth:'650px'}}/>          
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp} style={{borderBottom : '0px'}}>              
              <label>3) Edit the names of the columns or groups to reflect the count directions. (Volume reports: Edit &gt; Edit Column Titles. Speed/Class reports: Edit Group Description)</label>
              <p>Please note that the count directions in TraxPro must match the Station directions in DataPoint (e.g. an EB/WB Station will not accept a NB/SB count).</p>              
              <p className={classes.helpTestItalic}>Edit Column Titles pop-up for volume reports.</p>
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp} style={{borderBottom : '0px'}}>
            <img src={file_import_requirements_and_best_practices_3} alt="3) Edit the names of the columns or groups to reflect the count directions. (Volume reports: Edit &gt; Edit Column Titles. Speed/Class reports: Edit Group Description)" style={{width:'450px'}}/>          
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <p className={classes.helpTestItalic}>Edit Group Description for speed/class reports.</p>              
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>
            <img src={file_import_requirements_and_best_practices_4} alt="Edit Group Description for speed/class reports." style={{width:'450px'}}/>          
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <label>4) Paste the data from your external source into the TraxPro report.</label>
              <p>Note: DataPoint does not currently support dynamic bin headers for speed and class reports, so all speed and class data should be imported using the following schemes:</p>              
              <p>Speed: 0-15, 16-20, 21-25, 26-30, 31-35, 36-40, 41-45, 46-50, 51-55, 56-60, 61-65, 66-70, 71-75, 76-80</p>              
              <p>Class: FHWA 13-bin</p>              
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}></Grid>
            <Grid item xs={6} item className={classes.stepsHelp} style={{borderBottom : '0px'}}>              
              <label>5) Export the .prn file (File &gt; Export &gt; Peek/Streeter PRN)</label>
              <p>To export a .prn file, complete the information on the three-part pop-up sequence:</p>
              <label>Export pop-up #1:</label>
              <p className={classes.helpTestItalic}>Enter the DataPoint Station ID in the ID Number field (case sensitive). The Output Folder tells TraxPro where to save the file.</p>
              <p className={classes.helpTestItalic}>These settings will export a .prn for Station ID MB-018TZ to the user’s desktop.</p>
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp} style={{borderBottom : '0px'}}>
              <img src={file_import_requirements_and_best_practices_5} alt="Export pop-up #1" style={{width:'450px'}}/>          
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp} style={{borderBottom : '0px'}}>              
              <label>Export pop-up #2:</label>
              <p className={classes.helpTestItalic}>The information in the Time/Date – Interval section auto-populates based on the report.<br></br>
                Match the Day Options and Compatibility radio buttons to the example.</p>              
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp} style={{borderBottom : '0px'}}>
              <img src={file_import_requirements_and_best_practices_6} alt="Export pop-up #2" style={{width:'450px'}}/>          
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <label>Export pop-up #3:</label>
              <p className={classes.helpTestItalic}>In the Directions group, change the dropdown selections on the right to match the directions on the left. This is critical – the dropdowns tell DataPoint how to assign the directions.</p>              
              <p className={classes.helpTestItalic}>Choose any Lane Layout value – DataPoint does not read this value but TraxPro forces an entry before exporting.</p>
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>
              <img src={file_import_requirements_and_best_practices_7} alt="Export pop-up #3" style={{width:'450px'}}/>          
            </Grid> 
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <label>6) Update the file name</label>
              <p>TraxPro creates arbitrary file names for the exported .prn files. We recommend changing the name after exporting each file – “MB-0002 – 06-01-2012.prn.”</p>              
              <p>DataPoint only reads the internal file information but having a meaningful file name allows for better file management and a smoother import process.</p>
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}></Grid>
            <Grid item xs={12} item>                            
              <h5> Exporting a .txt file from PetraPro </h5>
              <p>DataPoint supports the import of turning movement counts in 5- and 15-minute intervals. Counts can be uploaded with passenger vehicles, heavy vehicles, bicycles, and pedestrian data. Jamar’s PetraPro software is the easiest way to create DataPoint-compatible turning movement count files.</p>                            
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp} style={{borderTop : '1px solid #eee'}}>              
              <label>1) Create a new count in PetraPro (File &gt; New)</label>
              <p className={classes.helpTestItalic}>New Count pop-up in PetraPro. These settings will create a count beginning at 6:00 AM on April 15th, 2021. Note that the number of classes is set to “3.”</p>                            
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp} style={{borderTop : '1px solid #eee'}}>
              <img src={file_import_requirements_and_best_practices_8} alt="1) Create a new count in PetraPro (File &gt; New)" style={{width:'550px'}}/>          
            </Grid> 
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <label>2) Confirm the approaches in the count match with the approaches in the DataPoint Station.</label>
              <p>The example to the right shows a count file for an intersection with four approaches. For a Station with three approaches, remove the non-existing approach from the count file.</p>                            
              <p className={classes.helpTestItalic}>A blank count file for a 4-leg intersection. The three class tabs are visible in the top left.</p>
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>
              <img src={file_import_requirements_and_best_practices_9} alt="2) Confirm the approaches in the count match with the approaches in the DataPoint Station." style={{width:'100%',maxWidth:'750px'}}/>          
            </Grid> 
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <label>3) Paste the data from your external source into the PetraPro count file.</label>
              <p>Movements: PetraPro defaults to Right/Thru/Left for the movement order. Adjust the order of the movements if your external source lists them in a different order. DataPoint will import the movements correctly regardless of the order.</p>                            
              <p>Be aware of the three class tabs when pasting in data from your external source. Data will be imported into DataPoint as follows:</p>
              <p>
                Class 1 – Passenger vehicles<br></br>
                Class 2 – Heavy vehicles<br></br>
                Class 3 – Bicycles (Left/Thru/Right) and Pedestrians by approach (U-turns)
              </p>
              <p>Note: Any class can be left blank (e.g. to upload a pedestrian-only count, paste data into the U-turns column of Class 3).</p>
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}></Grid> 
            <Grid item xs={6} item className={classes.stepsHelp}>              
              <label>4) Export the count data to an ASCII .txt file (File &gt; Export &gt; ASCII Text)</label>
              <p className={classes.helpTestItalic}>Match the export settings shown here.</p>                            
            </Grid>
            <Grid item xs={6} item className={classes.stepsHelp}>
              <img src={file_import_requirements_and_best_practices_10} alt="4) Export the count data to an ASCII .txt file (File &gt; Export &gt; ASCII Text)" style={{width:'300px'}}/>          
            </Grid>         
          </Grid>          
        </div>
        </div>
      </div>
    </React.Fragment>
  );
}
//End FileImportRequirementsAndBestPractices component code ...
